import { render, staticRenderFns } from "./setmarks.vue?vue&type=template&id=16f5e0fe&"
import script from "./setmarks.vue?vue&type=script&lang=js&"
export * from "./setmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports